import {createMultiPathSVG, createStrokeSVG} from './TEMPLATE'

// tabler: heart (fill weight)
export const Heart2_Filled_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M6.979 3.074a6 6 0 0 1 4.988 1.425l.037 .033l.034 -.03a6 6 0 0 1 4.733 -1.44l.246 .036a6 6 0 0 1 3.364 10.008l-.18 .185l-.048 .041l-7.45 7.379a1 1 0 0 1 -1.313 .082l-.094 -.082l-7.493 -7.422a6 6 0 0 1 3.176 -10.215z',
  ],
  viewBox: '0 0 24 24',
})

// tabler: heart
export const Heart2_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: heart
export const Heart2_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: heart
export const LikeRepost_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
